import { render } from "./geoLocation.vue?vue&type=template&id=1932b5e9&scoped=true"
import script from "./geoLocation.vue?vue&type=script&lang=js"
export * from "./geoLocation.vue?vue&type=script&lang=js"

import "./geoLocation.vue?vue&type=style&index=0&id=1932b5e9&lang=less&scoped=true"

import exportComponent from "D:\\Website desing\\kkiokio\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1932b5e9"]])

export default __exports__